<template>
    <transition name="fade">
        <button
            v-show="active"
            :class="{active}"
            class="control-button"
            @click="clickHandler"
        >
            <slot />
        </button>
    </transition>
</template>

<script>
import DirectionSlider from '@/mixins/DirectionSlider';

export default {
    name: 'ControlButton',
    mixins: [DirectionSlider],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        direction: {
            type: Number,
            default: 0
        }
    },
    methods: {
        clickHandler()
        {
            this.$audioController.play('button', {volume: 0.7});
            if (this.direction || this.slideHandler)
            {
                this.slideTo(this.direction);
            }
            this.$emit('click');
        }
    }
};
</script>

<style lang="scss" src="./ControlButton.scss" />
